import LocationsNewLocationDetails from "@/Shared/Locations/CustomComponents/LocationsNewLocationDetails";
import {
  locationsErrorMessagesForPickupLocation,
  warningMessagesForPickupLocation,
} from "@/Shared/Locations/Validators/locationsErrorMessagesForPickupLocation";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface PickupDetailsPageProp {
  shipment: Shipment;
}

export function ModifyShipmentPickupDetailsPage(props: PickupDetailsPageProp) {
  const errorMessages = locationsErrorMessagesForPickupLocation(
    props.shipment.pickupDate,
    props.shipment.pickupLocation,
  );
  const warningMessages = warningMessagesForPickupLocation(
    props.shipment.pickupLocation,
  );
  return (
    <LocationsNewLocationDetails
      locationErrorMessages={errorMessages}
      locationWarningMessages={warningMessages}
      context={LocationContext.Pickup}
      setLocation={() => {}}
      location={props.shipment.pickupLocation}
      forceValidation={false}
      disablePostalCodeEntry={false}
      pickupDate={props.shipment.pickupDate}
    />
  );
}
